import '@babel/polyfill';
import './pre.authentication.layout.entry.scss';
import 'bootstrap';
import $ from 'jquery';
import Vue from 'vue';

const errorBanner = new Vue({
    el: '#error-banner',
    data: {
        hasError: false
    },
    mounted: function () {
        //on any ajax errors (excluding validation errors [badmodelstate - 400]...show the error banner
        $(document).ajaxError((event, jqxhr, settings, thrownError) => {

            //400 = bad model state
            if (jqxhr.status != 400) {

                //set the variable so the banner is shown
                this.hasError = true;

                //scroll to the top of the page so they can see the banner
                $('html,body').animate({ scrollTop: 0 }, 0);
            }
        });

        $(document).ajaxSuccess((event, jqxhr, settings, thrownError) => {
            if (jqxhr.responseJSON.redirectUrl) {
                window.location.href = jqxhr.responseJSON.redirectUrl;
            }
        });

    }
});